import React, { useEffect, useState } from "react";
import "./dashboard.scss";
// import EmptyState from "../../shared/components/EmptyState";
import AppHeader from "../../shared/components/AppHeader";
import moment from "moment";
import StudentMetrics from "./StudentMetrics";
import StudentActivities from "./StudentActivities";
import ContentMetrics from "./ContentMetrics";
// import ContentAccessed from "./ContentAccessed";
import StudentPerformance from "./StudentPerformance";
import { Col, Row } from "antd";
import MostWatchedContent from "./MostWatchedContent";
import MostAttemptedQuiz from "./MostAttemptedQuiz";
import MostLikedContent from "./MostLikedContent";
import MostDislikedContent from "./MostDislikedContent";
// import { MetaModel } from "../../models/CourseModels/SubjectModel/subject.model";
// import { StudentMetricsModel } from "../../models/DashboardModel/StudentMetricsModel/studentMetrics.model";

import DownlaodLoginReport from "./DownlaodLoginReport";
import TutorActivities from "./TutorActivities";
import SchoolLoginDetails from "./SchoolLoginDetails";

const Dashboard = (props: any) => {

  return (
    <div className="page-view dashboard">
      <AppHeader
        headerSubtitle={moment().format("dddd, DD MMMM YYYY")}
        headerText="Dashboard"
        showBreadCrumb={false}
        showFilter={false}
        showSearch={false}
        showButton={false}
      />

      <StudentMetrics {...props}/>
      <SchoolLoginDetails {...props} />
      <TutorActivities {...props}/>
      <StudentActivities {...props}/>

      {/*<ContentAccessed /> */}
      <StudentPerformance {...props}/>

      {props?.user?.roleName === "admin"
        ? <ContentMetrics {...props}/>
        : null
      }

      <Row className="most__wrapper" gutter={[24, 24]}>
        <Col span={12}>
          <MostWatchedContent {...props}/>
        </Col>
        <Col span={12}>
          <MostAttemptedQuiz {...props}/>
        </Col>
        <Col span={12}>
          <MostLikedContent {...props}/>
        </Col>
        <Col span={12}>
          <MostDislikedContent {...props}/>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
